
// type IconProps = SVGProps<SVGSVGElement>;
// const Icon: FC<IconProps> = ({ children, ...props }) => (
//     <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-icon">
//         {children}
//     </svg>
// );
export type IconProps = React.SVGProps<SVGSVGElement>;

/**
 * MenuIcon (Hamburger) - Used for mobile navigation toggle.
 */
export const MenuIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

/**
 * XIcon (Close) - Used for mobile navigation closing button.
 */
export const XIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

/**
 * CodeIcon - Represents Web Application Development service.
 */
export const CodeIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"></polyline>
    <polyline points="8 6 2 12 8 18"></polyline>
  </svg>
);

/**
 * CloudIcon - Represents Cloud & Infrastructure service.
 */
export const CloudIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.5 19H9a7 7 0 1 1-6.75-9.72A5.5 5.5 0 0 1 12 2.5a5.5 5.5 0 0 1 5.5 5.5V8a6 6 0 0 1 4 4.5 5 5 0 0 1-5 6.5z"></path>
  </svg>
);

/**
 * SpeedometerIcon - Represents Performance Optimization service.
 */
export const SpeedometerIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"></path>
    <path d="M12 12h-4"></path>
    <path d="M16 12l-2-2"></path>
  </svg>
);

/**
 * ArrowRightIcon - Used for linking to case studies/projects.
 */
export const ArrowRightIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

/**
 * PhoneIcon - Used for general contact/footer links.
 */
export const PhoneIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-5.38-5.38A19.79 19.79 0 0 1 2.08 6.18 2 2 0 0 1 4.08 4h3a2 2 0 0 1 2 2.16L8.5 11l-3 3 3 3 4-4v3.5l-3 3 3 3 4 4 3-3z"/>
  </svg>
);

/**
 * MailIcon - Used for email contact details.
 */
export const MailIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
  </svg>
);

/**
 * SendIcon - Used for the submit button on the contact form.
 */
export const SendIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </svg>
);

/**
 * WhatsAppIcon - Used for the WhatsApp contact link.
 */
export const WhatsappIcon = (props: IconProps) => (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <path d="M12.04 2c-5.46 0-9.92 4.46-9.92 9.92 0 1.55.42 3.03 1.22 4.36L2.05 22l5.96-1.58c1.24.7 2.67 1.07 4.03 1.07 5.46 0 9.92-4.46 9.92-9.92S17.5 2 12.04 2zm5.06 14.65c-.2-.1-.76-.38-1.32-.65-.56-.27-.97-.37-1.38.3s-.79 1.05-1.19 1.13c-.4.08-.79.03-1.49-.41-1.44-.92-2.39-2.28-3.03-3.7-.63-1.43-.1-2.2.34-2.64.38-.38.79-.56 1.06-.84.27-.27.35-.64.25-.94-.1-.3-.37-.76-.52-1.07-.16-.3-.32-.35-.57-.36h-.41c-.22 0-.58.07-.88.35-.31.28-1.15 1.12-1.15 2.73s1.17 3.16 1.33 3.39c.16.23 2.3 3.53 5.56 4.88 3.26 1.35 3.96 1.08 4.69.96.73-.12 2.05-.82 2.34-1.63.29-.81.29-1.5.2-1.63-.09-.13-.35-.2-.72-.37z"/>
    </svg>
);

export const LoaderIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-loader-2 animate-spin">
    <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
  </svg>
);

/**
 * AlertTriangleIcon - Used for displaying warning or error messages.
 */
export const AlertTriangleIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

/**
 * CheckCircleIcon - Used for success or completed states.
 */
export const CheckCircleIcon = (props: IconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);